<template>
  <div class="main-container">
    <Header />

    <Breadcrumb :items="items" title="تماس با ما" />

    <ContactMainWrapper />

    <!-- <BrandCarousel addClass="grey-bg" /> -->

    <Footer />

    <OffCanvasMobileMenu />

    <!-- back to top start -->
    <back-to-top class="scroll-top" bottom="60px">
      <i class="ion-android-arrow-up"></i>
    </back-to-top>
    <!-- back to top end -->
  </div>
</template>

<script>
import Header from "@/components/Header"
import Breadcrumb from "../components/Breadcrumb"
import ContactMainWrapper from "../components/sections/ContactMainWrapper"
import BrandCarousel from "../components/BrandCarousel"
import Footer from "../components/Footer"
import OffCanvasMobileMenu from "@/components/OffCanvasMobileMenu"

export default {
  components: {
    Header,
    Breadcrumb,
    ContactMainWrapper,
    BrandCarousel,
    Footer,
    OffCanvasMobileMenu,
  },
  data() {
    return {
      items: [
        {
          text: "خانه",
          to: "/",
        },
        {
          text: "تماس",
          active: true,
        },
      ],
    }
  },
  metaInfo: {
    title: "کاسترو - تماس با ما",
    htmlAttrs: {
      lang: "fa",
      amp: true,
    },
  },
}
</script>
